export default {
  heroLine1: 'Dokonalý',
  heroLine2: 'hráčský',
  heroLine3: 'ráj',
  browseCatalog: 'Procházet katalog',
  featuredTitle: 'Tento týden doporučujeme',
  viewMore: 'Zobrazit více',
  platformsTitle: 'Platformy',
  howTitle: 'Jak PlayStock funguje',
  step1Title: 'Vyberte si hru',
  step1Body: 'Procházejte náš pečlivě vybraný výběr ověřených digitálních titulů.',
  step2Title: 'Zaplaťte v eurech svou peněženkou',
  step2Body: 'Bezpečná platba pomocí vašeho oblíbeného evropského platebního způsobu.',
  step3Title: 'Získejte klíč — okamžitě',
  step3Body: 'Žádné čekání. Aktivační kód obdržíte v okamžiku, kdy se platba zpracuje.',
  emptyTitle: 'Zatím žádné nabídky',
  emptyFailed: 'Nepodařilo se připojit ke katalogovému API. Spusťte backend a poté obnovte stránku.',
  emptyBefore: 'Katalog je prázdný. Přidejte svůj ',
  emptyKey: 'API klíč Kinguin sandbox',
  emptyAfter: ' do ',
  emptyAfter2: ' a spusťte synchronizaci.',
};
